import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'

import { Provider } from 'react-redux'
import store from './store'

// If debugging on localhost then just use local configuration constants.
// If deploying to ArgoCD, use Kubernetes settings from the Docker
// substituted config.json file.

const configFilePath = (window.location.hostname === "localhost") ? '/config.local.json' : '/porting/config.json';
// console.log(`LOG: Porting Hostname=${window.location.hostname} Node_Env=${process.env.NODE_ENV} Config Path='${configFilePath}'.`);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Initializes to default deployment configuration
let configuration = {
  ACCT_MGT_DEPLOY_ENV: "Dev",
  ACCT_MGT_PORTING_FRONTEND: "https://www-dev.lively.com",
  ACCT_MGT_PORTING_BACKEND: "https://www-dev.lively.com"
};

// Fetch deployment configuration file and place it in
// React context to be made available to any component
fetch (configFilePath)
  .then((r) => r.json())
  .then((fetched_config) => {
    // check configuration file validity
    if (fetched_config.ACCT_MGT_DEPLOY_ENV &&
       (fetched_config.ACCT_MGT_DEPLOY_ENV !== "$ACCT_MGT_DEPLOY_ENV")) {
        // fetched deployment configuration valid
        configuration = fetched_config;
        // console.log('Fetched deployment configuration:');
        // console.log(fetched_config);
    } else {
      console.error(`'${configFilePath}' was NOT processing by Docker script. Assuming default configurations.`);
    }
  })
  .catch((err) => {
    console.error(`Fetching '${configFilePath}'. Using default deployment configuration.`);
  })
  .finally(() => {
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App config={configuration} />
        </Provider>
      </React.StrictMode>
    );
    document.getElementById('root')
  });


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
